export const CREATORS = ['koharubiyori_51'] as const
export type CREATOR = (typeof CREATORS)[number]

export const creatorMapTargetId: Record<CREATOR, string> = {
  koharubiyori_51: 'gundamEvolution1',
}

export const mapGundamEvolutionCreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
    creatorImageURL: string
  }
> = {
  koharubiyori_51: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['koharubiyori_51']}/0.png`,
    creatorImageURL: '/static/images/creators/koharubiyori_51.png',
  },
}
